export const getSymbolNumericRandomKey = () => {
  return Math.random().toString(36).substring(2).slice(0, 10)
}

export const setClassName = (className: string, object: Object) => {
  object['__class'] = className
} 